import type { SxProps, Theme } from '@portals/core/src/themes/themes';

export const getStyles = (theme: Theme): { [key: string]: SxProps } => ({
  filterPill: {
    '&:focus, &:focus-visible, &.Mui-focused': {
      outline: `2px solid ${theme.palette.action.focus}`,
      outlineOffset: '2px',
    },
  },
  filterPillIcon: {
    height: { lg: 24 },
    width: { lg: 24 },
  },
});
